import _get from "lodash/get";
import { useEffect } from 'react';
import { useIdentityContext } from 'react-netlify-identity/dist/index';
import { useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';

var useUser = function useUser() {
  var _useIdentityContext = useIdentityContext(),
      user = _useIdentityContext.user,
      getFreshJWT = _useIdentityContext.getFreshJWT,
      logoutUser = _useIdentityContext.logoutUser;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var tokenObject = _get(user, 'token');

  var tokenExpires = _get(user, 'token.expires_at');

  var nowDate = Date.now();
  useEffect(function () {
    if (tokenExpires && tokenExpires < nowDate) {
      load(getFreshJWT()).then(function (res) {
        // eslint-disable-next-line no-console
        console.log('res', res);
        return res;
      }).catch(function (err) {
        if (user) {
          load(logoutUser()).then(function (res) {
            // eslint-disable-next-line no-console
            console.log('res', JSON.stringify(res));
            return res;
          }).catch(function (logoutError) {
            // eslint-disable-next-line no-console
            console.log('logoutError', JSON.stringify(logoutError));
            return logoutError;
          });
        } // eslint-disable-next-line no-console


        console.log('err', JSON.stringify(err));
        return err;
      });
    }

    if (user && !tokenObject) {
      load(logoutUser()).then(function (res) {
        // eslint-disable-next-line no-console
        console.log('user && !tokenObject res', JSON.stringify(res));
        return res;
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.log('user && !tokenObject err', JSON.stringify(err));
        return err;
      });
    }
  }, [getFreshJWT, nowDate, load, tokenObject, logoutUser, tokenExpires, user]);

  if (isLoading) {
    // eslint-disable-next-line no-console
    console.log('useUser loading');
  }

  return [user, isLoading];
};

export default useUser;